
import { FormEvent } from "react";
import KickImage from 'Reuseables/KickImage';
export type SelectedLogistic = {
  text: string;
  value: string;
}
export type SelectedSchedule = { start_time: string; end_time: string; }

export interface DateInterface {
  day: string;
  date: string;
  suffix: string;
  month: string;
  fullDay?: string;
  year: string;
  timeslot: Timeslot[];
  required?: boolean;
}
interface Timeslot {
  start_time: string;
  end_time: string;
  isPassed?: boolean;
}

type DropoffPayload = {
  saleId: number;
  seller_courier: string;
  AWB_number: string;
  AWB_photo: File;
}

export interface CourierInterface {
  active?: boolean;
  code?: string;
  created_at?: string;
  display_name?: string;
  id?: number;
  name?: string;
  text?: string;
  value?: string;
}

export interface WrapperInterface {
  sale_id?: number;
  onBack: () => void;
  submitSuccess: () => void;
  isConsignments: boolean;
}

export interface AwbOrSelfDropoffInterface {
  selectedLogistic: SelectedLogistic;
  awbNumber: string;
  selectedScheduled: SelectedSchedule;
  selectedDate: DateInterface | null;
  onChangeAwbNumber?: (e: FormEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setDropoffScheduled: (args: boolean) => void;
  parseTextHandler: (args?: string) => void;
}

export interface MainInterface extends AwbOrSelfDropoffInterface {
  loading: boolean;
  isValid: boolean;
  photo: File | null;
  photoUrl: string;
  courierList: Array<CourierInterface>;
  setPhotoHandler: (args: File) => void;
  onBack: () => void;
  deletePhoto: () => void;
  onChangeLogistic: (e: FormEvent<HTMLInputElement>) => void;
  onSelectLogistic: (e?: any) => void;
  submitDropoffHandler: () => void;
}

export interface DateCardInterface {
  scheduledList: Array<DateInterface>;
  selectedDate: DateInterface | null;
  setSelectedDate: (args: DateInterface | null) => void;
}

export interface TimeslotCardInterface {
  selectedDate: DateInterface | null;
  selectedScheduled: SelectedSchedule;
  setSelectedScheduled: (args: Timeslot) => void;
}

export interface DropoffScheduleInterface extends DateCardInterface, TimeslotCardInterface {
  loading: boolean;
  setDropoffScheduled: (args: boolean) => void;
}

export const TIMESLOT = [
  {
    start_time: "09.00",
    end_time: "11.59",
    end_time_eum: 9
  },
  {
    start_time: "12.00",
    end_time: "14.59",
    end_time_eum: 12
  },
  {
    start_time: "15.00",
    end_time: "17.59",
    end_time_eum: 15
  },
]